import React, { Component } from "react";
import {
    Paper, Typography, Box, Table, TableHead, TableBody, TableRow, TableCell, Divider,
    Button, CircularProgress
} from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PaymentIcon from '@mui/icons-material/Payment';
import NotesIcon from '@mui/icons-material/Notes';
import InventoryIcon from '@mui/icons-material/Inventory';
import PaidIcon from '@mui/icons-material/Paid';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import moment from "moment";

const cookies = new Cookies();

export default class InvoiceDisplay extends Component {
    state = {
        invoiceNumber: 1418,
        traderName: "أحمد التاجر",
        date: "2025-07-05",
        transportCost: 10000,
        notes: "تم التوصيل بنجاح",
        paymentType: "كاش",
        isTransferred: false,
        items: [],
        paidAmount: 150000,
        totalPrice: 200000,
        remainingAmount: 50000,
        is_transfer: false,
        safeCheck: false,
        loadingAccept: false,
        loadingReject: false,
        status: 0,
        loadingPage: true, // جديد
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let id = urlParams.get('id');
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };

        axios.get(host + `dashbord/bill/parts/bill/${id}`, { headers: header })
            .then(res => {
                const bill = res.data.bills;
                const arry = bill.prats.map(prt => ({
                    name: prt.parts.name,
                    quantity: prt.count,
                    price: prt.price,
                    types: prt.dev.map(devItem => devItem.item.name)
                }));

                this.setState({
                    items: arry,
                    invoiceNumber: bill.id,
                    status: bill.status,
                    traderName: bill.suppliers.name,
                    date: moment(bill.created_at).format('YYYY-MM-DD'),
                    transportCost: bill.shipping,
                    notes: bill.notes,
                    paidAmount: bill.paid_amount,
                    totalPrice: bill.t_amount,
                    is_transfer: bill.is_transfer,
                    safeCheck: bill.safeCheck,
                    remainingAmount: bill.total_price - bill.paid_amount,
                    paymentType: bill.payed === 1 ? "كاش" : "آجل",
                    loadingPage: false, // انتهاء التحميل
                });
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ loadingPage: false }); // حتى لو صار خطأ
            });
    }

    getTotalQuantity = () => this.state.items.reduce((sum, item) => sum + item.quantity, 0);

    add() {
        const confirmed = window.confirm("هل أنت متأكد من قبول الفاتورة؟");
        if (!confirmed) return;

        this.setState({ loadingAccept: true });
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.post(host + `dashbord/bill/parts/chenge/${this.state.invoiceNumber}`, {
            "allcount": this.getTotalQuantity(),
            "status": "1",
        })
            .then(() => {
                window.alert("تم قبول الفاتورة بنجاح");
                this.setState({ loadingAccept: false });
                this.componentDidMount(); // إعادة تحميل البيانات
            })
            .catch(() => {
                this.setState({ loadingAccept: false });
                     this.componentDidMount(); // إعادة تحميل البيانات

            });
    }

    reject() {
        const confirmed = window.confirm("هل أنت متأكد من رفض الفاتورة؟");
        if (!confirmed) return;

        this.setState({ loadingReject: true });
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.post(host + `dashbord/bill/parts/chenge/${this.state.invoiceNumber}`, {
            "allcount": this.getTotalQuantity(),
            "status": "3",
        })
            .then(() => {
                window.alert("تم رفض الفاتورة بنجاح");
                this.setState({ loadingReject: false });
                this.componentDidMount(); // إعادة تحميل البيانات
            })
            .catch(() => {
                this.setState({ loadingReject: false });
                     this.componentDidMount(); // إعادة تحميل البيانات
            });
    }

    render() {
        if (this.state.loadingPage) {
            return (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100vh"
                    width="100%"
                    sx={{ backgroundColor: '#f0f0f0' }}
                >
                    <CircularProgress size={60} />
                </Box>
            );
        }

        const {
            invoiceNumber, traderName, date, transportCost, notes,
            paymentType, items, paidAmount, totalPrice,
            is_transfer, safeCheck, status,
            loadingAccept, loadingReject
        } = this.state;

        const remainingAmount = totalPrice - paidAmount;

        return (
            <Paper elevation={3} style={{ padding: 0, maxWidth: 1000, margin: 'auto', marginTop: 32, direction: 'rtl', backgroundColor: '#fdfdfd' }}>
                {/* شريط الرجوع */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        backgroundColor: '#000',
                        color: '#fff',
                        padding: '10px 24px'
                    }}
                >
                    <Typography sx={{ color: '#fff', fontSize: '1rem', fontWeight: 'bold' }}>
                        فاتورة المواد
                    </Typography>
                    <Box
                        onClick={() => window.history.back()}
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    >
                        <Typography sx={{ color: '#fff', fontSize: '1rem', fontWeight: 'bold', ml: 1 }}>
                            رجوع
                        </Typography>
                        <ArrowBackIosNewIcon sx={{ color: '#fff', fontSize: '1.2rem' }} />
                    </Box>
                </Box>

                <Box sx={{ padding: 4 }}>
                    <Paper elevation={3} style={{ padding: 32, maxWidth: 1000, margin: 'auto', marginTop: 32, direction: 'rtl', backgroundColor: '#fdfdfd', fontSize: '1.1rem' }}>
                        <Typography variant="h4" gutterBottom style={{ color: '#2b4c7e', textAlign: "center", fontSize: '2.2rem' }}>فاتورة مواد الصيانة</Typography>
                        <Divider style={{ margin: '16px 0', backgroundColor: '#2b4c7e' }} />

                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h6" style={{ fontSize: '1.2rem' }} color="textSecondary"><strong>رقم الفاتورة:</strong> #{invoiceNumber}</Typography>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Box display="flex" alignItems="center">
                                <PersonIcon style={{ marginLeft: 8, color: '#3f51b5' }} />
                                <Typography variant="h6" style={{ fontSize: '1.2rem' }}><strong>اسم التاجر:</strong> {traderName}</Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <CalendarTodayIcon style={{ marginLeft: 8, color: '#3f51b5' }} />
                                <Typography variant="h6" style={{ fontSize: '1.2rem' }}><strong>تاريخ الإدخال:</strong> {date}</Typography>
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Box display="flex" alignItems="center">
                                <PaymentIcon style={{ marginLeft: 8, color: '#009688' }} />
                                <Typography
                                    variant="h6"
                                    style={{
                                        fontSize: '1.2rem',
                                        padding: '4px 12px',
                                        borderRadius: '10px',
                                        backgroundColor: paymentType === "كاش" ? '#e8f5e9' : '#ffebee',
                                        color: paymentType === "كاش" ? '#2e7d32' : '#c62828'
                                    }}
                                >
                                    <strong>نوع الدفع:</strong> {paymentType}
                                </Typography>
                            </Box>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center">
                                    <LocalShippingIcon style={{ marginLeft: 8, color: '#009688' }} />
                                    <Typography variant="h6" style={{ fontSize: '1.2rem' }}>
                                        <strong>تكلفة النقل:</strong> {transportCost.toLocaleString()} د.ع
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            fontSize: '1.1rem',
                                            color: !safeCheck ? '#2e7d32' : '#c62828',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {!safeCheck ? 'تم دفع مصاريف النقل كاش' : 'تم دفع مصاريف النقل آجل'}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Box display="flex" alignItems="center" mb={2}>
                            <NotesIcon style={{ marginLeft: 8, color: '#ff9800' }} />
                            <Typography variant="h6" style={{ fontSize: '1.2rem' }}><strong>ملاحظات:</strong> {notes}</Typography>
                        </Box>

                        <Box display="flex" alignItems="center" mb={2}>
                            <CheckCircleIcon
                                style={{
                                    color: is_transfer ? '#4caf50' : '#cfd8dc',
                                    marginLeft: 8
                                }}
                            />
                            <Typography variant="body1" style={{
                                fontSize: '1.1rem',
                                color: is_transfer ? '#4caf50' : '#9e9e9e',
                                fontWeight: 'bold'
                            }}>
                                تم تحويل المبلغ
                            </Typography>
                        </Box>

                        <Divider style={{ margin: '16px 0', backgroundColor: '#2b4c7e' }} />
                        <Box display="flex" alignItems="center" mb={1}>
                            <InventoryIcon style={{ marginLeft: 8, color: '#3f51b5' }} />
                            <Typography variant="h5" style={{ fontSize: '1.6rem' }}>تفاصيل المواد</Typography>
                        </Box>

                        <Table>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#e3f2fd' }}>
                                    {["اسم المنتج", "عدد المنتج", "سعر القطعة", "نوع الجهاز", "الإجمالي"].map((head, i) => (
                                        <TableCell key={i} style={{ fontSize: '1.1rem' }}><strong>{head}</strong></TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={{ fontSize: '1.05rem' }}>{item.name}</TableCell>
                                        <TableCell style={{ fontSize: '1.05rem' }}>{item.quantity}</TableCell>
                                        <TableCell style={{ fontSize: '1.05rem' }}>{item.price.toLocaleString()} د.ع</TableCell>
                                        <TableCell>
                                            {item.types.map((type, i) => (
                                                <Box
                                                    key={i}
                                                    component="span"
                                                    sx={{
                                                        display: 'inline-block',
                                                        px: 1.5,
                                                        py: 0.5,
                                                        mr: 1,
                                                        mb: 0.5,
                                                        borderRadius: '12px',
                                                        fontSize: '0.9rem',
                                                        backgroundColor: '#e1f5fe',
                                                        color: '#0277bd',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            backgroundColor: '#81d4fa',
                                                            color: '#01579b'
                                                        }
                                                    }}
                                                >
                                                    {type}
                                                </Box>
                                            ))}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '1.05rem' }}>{(item.quantity * item.price).toLocaleString()} د.ع</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                        <Divider style={{ margin: '16px 0', backgroundColor: '#2b4c7e' }} />

                        <Box display="flex" justifyContent="space-between" mt={2}>
                            <Typography variant="h6" color="primary" style={{ fontSize: '1.2rem' }}>
                                <strong>مجموع الكلي للقطع:</strong> {this.getTotalQuantity()}
                            </Typography>

                            <Box display="flex" flexDirection="column" alignItems="flex-end">
                                <Typography variant="h6" color="primary" style={{ fontSize: '1.2rem' }}>
                                    <strong>المجموع الكلي للسعر:</strong> {totalPrice.toLocaleString()} د.ع
                                </Typography>

                                <Box display="flex" alignItems="center" mt={1}>
                                    <PaidIcon style={{ marginLeft: 8, color: '#4caf50' }} />
                                    <Typography variant="h6" color="success.main" style={{ fontSize: '1.2rem' }}>
                                        <strong>المبلغ المدفوع:</strong> {paidAmount.toLocaleString()} د.ع
                                    </Typography>
                                </Box>

                                <Box display="flex" alignItems="center" mt={1}>
                                    <Typography
                                        variant="h6"
                                        style={{
                                            fontSize: '1.2rem',
                                            color: '#d32f2f',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        المبلغ المتبقي: {remainingAmount.toLocaleString()} د.ع
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        {status === 0 && (
                            <Box display="flex" justifyContent="center" gap={3} mt={4}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    style={{ fontSize: '1rem', padding: '10px 24px' }}
                                    onClick={() => this.add()}
                                    disabled={loadingAccept}
                                >
                                    {loadingAccept ? <CircularProgress size={24} color="inherit" /> : 'قبول القائمة'}
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    style={{ fontSize: '1rem', padding: '10px 24px' }}
                                    onClick={() => this.reject()}
                                    disabled={loadingReject}
                                >
                                    {loadingReject ? <CircularProgress size={24} color="error" /> : 'رفض القائمة'}
                                </Button>
                            </Box>
                        )}
                    </Paper>
                </Box>
            </Paper>
        );
    }
}
